/*
 *   File : signature-preview.js
 *   Author URI : https://evoqins.com
 *   Description : Preview modal for uploaded image
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect } from "react";
import style from "../../Styles/Component/signature-preview.module.scss"
import Icon from "../Icon/icon";
import { GradientButton } from "../CTA";

const SignaturePreviewModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("signature-preview");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    const isPdf =
        props.file &&
        props.file.split('?')[0].toLowerCase().endsWith('.pdf');


    const _downloadFile = () => {
        const link = document.createElement("a");
        link.href = props.file;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div className={`modal fade ${style.e_signature_modal}`}
            id="signature-preview"
            tabIndex="-1"
            aria-labelledby="signature-preview"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content p-4 ${style.e_content} `}>
                    <div className="mb-4 d-flex align-items-center justify-content-between">
                        <p className="color-black e-poppins-medium e-font-16 line-height-16px mb-0">Preview your document</p>
                        <Icon icon="close"
                            size={24}
                            data-bs-dismiss="modal"
                            className="cursor-pointer e-modal-close-btn" />
                    </div>
                    <div className="mx-5 border-radius-16px border-all border-bright-gray">
                        {
                            isPdf ? (
                                <div className="d-flex justify-content-center px-4 py-4">
                                    <GradientButton
                                        label="Download PDF"
                                        handleClick={_downloadFile}
                                        className="px-3 padding-12px-tb e-font-14"
                                    />
                                </div>
                            ) : (
                                <div className="d-flex align-items-center justify-content-center p-4">
                                    <img
                                        src={props.file}
                                        alt="File preview"
                                        style={{ maxHeight: "400px", objectFit: "contain" }}
                                        className="border-radius-16px"
                                    />
                                </div>
                            )
                        }

                        {
                            props.showLocation && props.location &&
                            <p className="color-black e-poppins-medium e-font-12 ps-3 mb-2">
                                {props.location}
                            </p>
                        }
                    </div>


                </div>
            </div>
        </div>
    )
}

export default SignaturePreviewModal